var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_25118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18902 23.4423H0.199219V7.96875H6.18902V23.4423ZM1.19746 22.444H5.19078V8.96699H1.19746V22.444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.16 23.4423H17.1702V14.9568C17.1702 14.1298 16.4998 13.4593 15.6728 13.4593C14.8457 13.4593 14.1753 14.1298 14.1753 14.9568V23.4423H8.18555V7.96875H14.1753V8.97321C15.0794 8.31953 16.1669 7.96802 17.2825 7.96875C20.5207 7.96875 23.16 10.5955 23.16 13.8275V23.4423ZM18.1685 22.444H22.1616V13.8275C22.1549 11.1386 19.9714 8.96352 17.2825 8.96699C16.0534 8.96699 14.899 9.48485 14.0381 10.4208L13.1769 11.3629V8.96699H9.18379V22.444H13.1769V14.9568C13.1769 13.5783 14.2943 12.4611 15.6728 12.4611C17.0511 12.4611 18.1685 13.5783 18.1685 14.9568V22.444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19412 6.97417C1.54001 6.97417 0.199219 5.63338 0.199219 3.97927C0.199219 2.32535 1.54001 0.984375 3.19412 0.984375C4.84822 0.984375 6.18902 2.32535 6.18902 3.97927C6.18554 5.63192 4.84676 6.97088 3.19412 6.97417ZM3.19412 1.9828C2.0915 1.9828 1.19746 2.87666 1.19746 3.97927C1.19746 5.08207 2.0915 5.97593 3.19412 5.97593C4.29673 5.97593 5.19078 5.08207 5.19078 3.97927C5.19078 2.87666 4.29673 1.9828 3.19412 1.9828Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_25118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9609,
    height: 22.9609,
    fill: "white",
    transform: "translate(0.199219 0.71875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.15c63247ce2b1ee6ad8a6cb23f891cfe.svg";
export { ForwardRef as ReactComponent };